<template>
	<div class="home">
		<div id="bagbag" v-if="showliusif" @click="showliusif = false">
			
		</div>
		<img class="logo" src="../assets/images/logo.png" />
		<div class="itembox">
			<div class="box-top">
				<a href="javascript:void(0);" @click="showliusif = true" class="btnbtnbtn tttt">
					<div class="cc1" v-if="!showliusif">
						<img class="itembag" src="../assets/images/item1.png" />
						<img id="ico" class="itemico" src="../assets/images/itemico1.png" />
					</div>
					<div class="cc2" id="cc2" v-if="showliusif">
						<div class="cc2bb">
							<div class="ff"><a :href="$api.biographyUrl" target="_blank"><span>生平篇</span></a></div>
							<img class="borderitem" src="../assets/images/borderitem.png"/>
							<div class="ff" @click="inrouter('/item6')"><span>医德篇</span></div>
							<img class="borderitem" src="../assets/images/borderitem.png"/>
							<div class="ff" @click="inrouter('/item3')"><span>著作篇</span></div>
							<img class="borderitem" src="../assets/images/borderitem.png"/>
							<div class="ff" @click="inrouter('/item5')"><span>养生篇</span></div>
							<img class="borderitem" src="../assets/images/borderitem.png"/>
							<div class="ff" @click="inrouter('/item4')"><span>典故篇</span></div>
							<img class="borderitem" src="../assets/images/borderitem.png"/>
							<div class="ff" @click="inrouter('/item2')"><span>智慧篇</span></div>
							
							
						</div>
					</div>
				</a>
				<a href="javascript:void(0);" class="tttt" @click="inKnowledgebase"><img class="itembag"
						src="../assets/images/item2.png" /><img class="itemico"
						src="../assets/images/itemico2.png" /></a>
				<a href="javascript:void(0);" class="tttt" @click="invr('/vr')"><img class="itembag" src="../assets/images/item3.png" /><img
						class="itemico" src="../assets/images/itemico3.png" /></a>
			</div>
			<div class="box-bottom">
				<a href="javascript:void(0);" @click="inOnlineexamination"><img class="itembag"
						src="../assets/images/item5.png" /><img class="itemico2"
						src="../assets/images/itemico4.png" /></a>
				<a href="javascript:void(0);" @click="inPersonal"><img class="itembag"
						src="../assets/images/item4.png" /><img class="itemico2"
						src="../assets/images/itemico5.png" /></a>
			</div>
			<div class="bottom-center">
				<a href="javascript:void(0);" @click="showbag('教学意义')">
					<img src="../assets/images/center1.png" />
					<p>教学意义</p>
				</a>
				<a href="javascript:void(0);" @click="showbag('教学背景')">
					<img src="../assets/images/center2.png" />
					<p>教学背景</p>
				</a>
				<a href="javascript:void(0);" @click="showbag('教学目的')">
					<img src="../assets/images/center3.png" />
					<p>教学目的</p>
				</a>
				<a href="javascript:void(0);" @click="showbag('实验操作指南')">
					<img src="../assets/images/center4.png" />
					<p>实验操作指南</p>
				</a>
				<a href="javascript:void(0);" @click="showbag2('项目引导视频')">
					<img src="../assets/images/center5.png" />
					<p>项目引导视频</p>
				</a>
			</div>
		</div>

		<div class="mypopup" v-if="isshowbg">
			
			<div class="box" v-if="showlist!=null">
				<a href="javascript:void(0);" @click="closebag"><img class="close"
						src="../assets/images/tcclose.png" /></a>
				<homepopup ref="closebag" :txt="showlist.content" :title="showlist.title">
					<div v-html="videoss"></div>
				</homepopup>
			</div>
		</div>
		<div v-if="spshow" class="spsp">
			<a href="javascript:void(0);" @click="spshow = false"><img class="close"
					src="../assets/images/tcclose.png" /></a>
			<div class="spview" v-html="videoss">
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import homepopup from '../components/homepopup/homepopup.vue'
	import axios from 'axios'
	export default {
		name: 'Home',
		created() {
		},
		data() {
			return {
				isshowbg: false,
				token: this.$store.state.token,
				userid: this.$store.state.userid,
				classlist:[],
				showlist: null,
				videoss: "",
				spshow: false,
				showliusif: false
			}
		},
		components: {
			homepopup
		},
		created() {
			this.getlist()
		},
		methods: {
			showbag2(){
				this.videoss = ""
				this.classlist.map((item)=>{
					if(item.cmsCategoryList[0].name=="项目引导视频"){
						this.showlist = item
						let url = this.$api.imgUrl + '' + item.videoAtt.fastFileId
						this.videoss = '<video autoplay loop controlslist="nodownload" controls src="'+url+'" style="width:100%; height:100%;object-fit: fill;"></video>'
					}
				})
				this.spshow = true
			},
			getlist(){
				axios({
					method: 'GET',
					url: this.$api.commonUrl + 'posts',
					params:{
						pageNum: 1,
						pageSize: 999
					},
					headers: {
						"Authorization":"Bearer " + this.token
					},
					responseType: "json"
				}).then(res => {
					if (res.data.code == '200') {
						this.classlist = res.data.data.list
					} else {
						console.log(res.data.message)
					}
				}).catch(err => {
					console.log(err)
				})
			},
			inrouter(pathstr){
				this.$router.push(pathstr)
			},
			inKnowledgebase() {
				this.$router.push('/Knowledgebase')
			},
			inOnlineexamination() {
				this.$router.push('/onlineexamination')
			},
			inPersonal() {
				this.$router.push('/personal')
			},
			showbag(classname) {
				this.isshowbg = true
				this.videoss = ""
				if(classname=='教学意义'){
					this.classlist.map((item)=>{
						if(item.cmsCategoryList[0].name=="教学意义"){
							this.showlist = item
						}
					})
				}else if(classname=='教学背景'){
					this.classlist.map((item)=>{
						if(item.cmsCategoryList[0].name=="教学背景"){
							this.showlist = item
						}
					})
				}else if(classname=='教学目的'){
					this.classlist.map((item)=>{
						if(item.cmsCategoryList[0].name=="教学目的"){
							this.showlist = item
						}
					})
				}else if(classname=='项目引导视频'){
					this.classlist.map((item)=>{
						if(item.cmsCategoryList[0].name=="项目引导视频"){
							this.showlist = item
							let url = this.$api.imgUrl + '' + item.videoAtt.fastFileId
							this.videoss = '<video autoplay loop controlslist="nodownload" controls src="'+url+'" style="width:100%; height:100%;object-fit: fill;"></video>'
						}
					})
				}else if(classname=='实验操作指南'){
					this.classlist.map((item)=>{
						if(item.cmsCategoryList[0].name=="实验操作指南"){
							this.showlist = item
							if(item.videoAtt!=null){
								let url = this.$api.imgUrl + '' + item.videoAtt.fastFileId
								this.videoss = '<video autoplay loop controlslist="nodownload" controls src="'+url+'" style="width:100%; height:100%;object-fit: fill;"></video>'
							}
						}
					})
				}
			},
			closebag() {
				this.isshowbg = false
			},
			invr(path){
				this.$router.push(path)
			}
		}
	}
</script>

<style scoped>
	.spsp{
		position: fixed;
		z-index: 999;
		background: rgba(0,0,0,0.5);
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.spsp a img{
		width: 3rem;
		height: 3rem;
	}
	.spsp a{
		position: absolute;
		top: calc(10% - 3rem);
		right: calc(15% - 3rem);
		width: 3rem;
		height: 3rem;
	}
	#bagbag{
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		z-index: 98;
	}
	.spview{
		width: 70%;
		margin: 0px auto;
		margin-top: 6%;
	}
	.home {
		background: url(../assets/images/homebag.jpg) no-repeat;
		background-position: left center;
		background-size: 100% auto;
		position: absolute;
		top: 0px;
		left: 0px;
		right: 0px;
		border: 0px;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.home .logo {
		position: absolute;
		left: 2.5rem;
		top: 2.5rem;
		width: 18rem;
		height: auto;
		z-index: 2;
	}

	.home .itembox {
		width: 50rem;
		height: 100%;
		position: absolute;
		right: 8rem;
		top: 3.5rem;
		bottom: 0;
		margin: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-evenly;
	}

	.home .box-top{
		width: 100%;
		justify-content: space-between;
	}

	

	.home .box-top a,
	.home .box-bottom a {
		display: inline-block;
		position: relative;
	}

	.home .box-top a .itemico {
		position: absolute;
		width: 100%;
		height: auto;
		top: -2rem;
	}

/* 	.home .box-top a:nth-last-of-type(2) {
		margin-left: 4rem;
		margin-right: 4rem;
	} */


.home .box-top a{
	width: 14rem;
}
	.home .box-top a .itembag {
		width: 100%;
		height: auto;
		display: block;
	}

	.home .box-bottom {
		text-align: center;
		justify-content: space-between;
	}
.home .box-bottom a{
	width: 22.5rem;
}
	.home .box-bottom a .itembag {
		width: 100%;
	}
	.home .box-top,
	.home .box-bottom,
	.home .bottom-center {
		width: 100%;
		margin: 0px auto;
		display: flex;
	}

	.home .box-bottom a .itemico2 {
		position: absolute;
		width: 60%;
		height: auto;
		right: -2rem;
		bottom: -1rem;
	}

	.home .bottom-center {
		text-align: center;
	}

	.home .bottom-center a {
		flex: 1;
		text-decoration: none;
	}

	.home .bottom-center a img {
		width: 6rem;
		height: auto;
		display: block;
		margin: 0px auto;
	}

	.home .bottom-center p {
		font-size: 1.142857rem;
		color: #976849;
		line-height: 1.5rem;
		font-weight: bold;
		margin-top: 0.5rem;
	}

	.home .mypopup {
		position: fixed;
		z-index: 99;
		background: rgba(0, 0, 0, 0.5);
		top: 0px;
		left: 0px;
		right: 0px;
		bottom: 0px;
	}

	.home .mypopup .box {
		width: 55%;
		height: 80%;
		background: url(../assets/images/tcbag.png);
		background-size: 100% 100%;
		margin: auto;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		position: absolute;
	}

	.home .mypopup .close {
		position: absolute;
		width: 3rem;
		height: 3rem;
		right: -3rem;
		top: -3rem;
	}

	.home .homepopup::-webkit-scrollbar {
		width: 6px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	/*滚动条里面小方块*/
	.home .homepopup::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #af805c;
	}

	/*滚动条里面轨道*/
	.home .homepopup::-webkit-scrollbar-track {
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ede3db;
	}

	.home .cc1 {
		position: absolute;
		z-index: 2;
		width: 100%;
		height: auto;
	}

	.home .cc2 {
		z-index: 99;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: #FFFFFF;
		transition: all 0.5s;
		background: url(../assets/images/item222.png) no-repeat;
		background-size: 100%;
		width: 100%;
		height: auto;
	}

	.home .cc2 .cc2bb div {
		flex: 1;
		display:flex;
		align-items:center;
		text-align: center;
	}
.home .cc2 .cc2bb div span{
	width: 100%;
}
.home .cc2 .cc2bb div span img{
	width: 1rem;
	height: 1rem;
	display: inline-block;
	margin-left: 1rem;
	margin-right: 1rem;
}

	/* .home .btnbtnbtn:hover .cc2{
		opacity: 0;
	}
	.home .btnbtnbtn:hover .cc1 .itemico{
		opacity: 0;
	} */
	.home .cc2bb{
		position: absolute;
		left: 0.5rem;
		right: 0.5rem;
		top: 0.5rem;
		bottom: 0.5rem;
		display: flex;
		flex-direction: column;
	}
	.home .borderitem{
		width: 100%;
		height: auto;
		display: block;
	}
	.home .ff span{
		font-family: 'STXingkai';
		font-size: 1.6rem;
		font-weight: bold;
	}
	.home .ff,.home .ff a{
		position: relative;
		color: #ab7b58;
		text-decoration: none;
		width: 100%;
	}
	.home .ff:hover::before{
		content: "";
		position: absolute;
		width: 1rem;
		height: 1rem;
		background: url(../assets/images/jtright.png) no-repeat;
		background-size: 100%;
		left: 0.5rem;
		top: 0;
		bottom: 0;
		margin: auto;
	}
	.home .ff:hover::after{
		content: "";
		position: absolute;
		width: 1rem;
		height: 1rem;
		background: url(../assets/images/jtleft.png) no-repeat;
		background-size: 100%;
		right: 0.5rem;
		top: 0;
		bottom: 0;
		margin: auto;
	}
	.home .ff:hover{
		color: #5f3519 !important;
	}
	.home .ffactive .ff{
		color: #5f3519 !important;
	}
</style>
